export const DEPENDENT_TABLE_ROW_TEST_ID = 'dependent-table-row';
export const DEPENDENT_FULL_NAME_TEST_ID = 'dependent-full-name';
export const DEPENDENT_MEMBER_TYPE_TEST_ID = 'dependent-member-type';
export const DEPENDENT_DATE_OF_BIRTH_TEST_ID = 'dependent-date-of-birth';
export const DEPENDENT_ACTIONS_DROPDOWN_TEST_ID = 'dependent-actions-dropdown';
export const UPDATE_DEPENDENT_MODAL_TEST_ID = 'update-dependent-modal';
export const REMOVE_DEPENDENT_MODAL_TEST_ID = 'remove-dependent-modal';
export const SUBSCRIBER_DEPENDENTS_TABLE_TEST_ID = 'subscriber-dependents-table';
export const ADD_DEPENDENT_BUTTON_TEST_ID = 'add-dependent-button';
